<div class="dialog-wrap">
  <h1 mat-dialog-title class="dialog-title ellipsis">Delete User</h1>

  <div mat-dialog-content="" class="dialog-content">
    <div class="dialog-subtitle">Are you sure you want to delete {{ user.email }}?</div>
  </div>

  <div mat-dialog-actions="" class="dialog-actions d-flex justify-end">
    <span class="warning">Warning: this cannot be undone.</span>
    <div class="right-part d-flex align-items-center justify-end">
      <button class="btn btn-cancel dialog-btn" type="button" (click)="close()" mat-button="">Cancel</button>
      <button class="btn btn-blue dialog-btn" type="button" (click)="done()" mat-button="">Delete</button>
    </div>
  </div>
</div>
